import React from 'react';
import DialogMessage from '../../Dialog';
import { renderToString } from 'react-dom/server'
import { prettyDate } from '../../../utils/date';

const activeSchedulingsStructure = (data) => {
    const { tableData, message, submessage } = data;
    return (
        <>
            <strong style={{fontSize: '1.3em', textAlign: 'center', width: '100%', display: 'block'}}>
            {message}
            </strong>
            <b style={{textAlign: 'center', width: '100%', display: 'block', fontSize: '1em' }}>{submessage}</b>
            <hr />
            <table style={{width: '100%'}}
               data-cy="client-quota-overload"
               id="client-quota-overload"
            >
                <thead>
                    <tr>
                        <th style={{ textAlign: 'center' }}>Data</th>
                        <th style={{ textAlign: 'center' }}>Reservadas</th>
                        <th style={{ textAlign: 'center' }}>Capacidade</th>
                    </tr>
                </thead>
                <tbody>
                    {tableData && tableData.map((d, index) => (
                        <tr key={index}>
                            <td style={{textAlign: 'center'}}>{prettyDate(d.date)}</td>
                            <td style={{ textAlign: 'center' }}>{d.allocated}</td>
                            <td style={{ textAlign: 'center' }}>{d.available}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </>
    )
}

const ModalQuotaOverloaded = ({...props}) => {
    const {isOpen, closeReadingNotificationDialog} = props
    const table = renderToString(activeSchedulingsStructure(props))

    return <DialogMessage
                isOpen={isOpen}
                data-cy="client-quota-overload-feedback"
                id="client-quota-overload-feedback"
                closeReadingNotificationDialog={closeReadingNotificationDialog}
                message={table}
            >
    </DialogMessage>
}

export default ModalQuotaOverloaded;
